import { getInjector, getRootScope } from '@/services/angularjs-bridge';

import type { CommunicationPlans, CustomPublicationSettings } from '../types';

type PublicationAngularContext = {
    plans: CommunicationPlans;
    customPublicationSettings: CustomPublicationSettings | null;
    translateFormat: (format: string) => string;
    getErrorMessage: (error: unknown, defaultMessage: string) => string;
    user?: unknown;
    organization?: unknown;
};

const fallbackContext: PublicationAngularContext = {
    plans: {},
    customPublicationSettings: null,
    translateFormat: (format) => format,
    getErrorMessage: (_error, defaultMessage) => defaultMessage,
};

const getPublicationAngularContext = (): PublicationAngularContext => {
    try {
        const $rootScope = getRootScope(getInjector());
        const plans = typeof $rootScope.getPreparedCommunicationPlans === 'function'
            ? ($rootScope.getPreparedCommunicationPlans() ?? {})
            : ($rootScope.communicationPlans ?? {});
        const customPublicationSettings = typeof $rootScope.getService === 'function'
            ? $rootScope.getService('CustomPublicationSettings')
            : null;
        const translateFormat = (format: string) => {
            if (typeof $rootScope.translateValue === 'function') {
                return $rootScope.translateValue('COMMUNICATION_CHANNELS.FORMATS.', format);
            }
            return `COMMUNICATION_CHANNELS.FORMATS.${format}`;
        };
        const getErrorMessage = (error: unknown, defaultMessage: string) => {
            if (typeof $rootScope.getErrorMessage === 'function') {
                const axiosError = error as { response?: { data?: unknown } };
                return $rootScope.getErrorMessage(
                    axiosError.response ? { data: axiosError.response.data } : error,
                    defaultMessage,
                );
            }
            const axiosError = error as { response?: { data?: { message?: string } } };
            return axiosError.response?.data?.message ?? defaultMessage;
        };
        return {
            plans,
            customPublicationSettings,
            translateFormat,
            getErrorMessage,
            user: $rootScope.user,
            organization: $rootScope.organization,
        };
    } catch {
        return fallbackContext;
    }
};

export { getPublicationAngularContext };
export type { PublicationAngularContext };
